document.addEventListener("DOMContentLoaded", () => {
  const container = document.querySelector("[data-custom-option-groups]");
  if (!container) return;

  const groups = Array.from(container.querySelectorAll(".custom-option-group"));
  const summaryContainer = container.querySelector("[data-summary-container]");
  const summaryText = container.querySelector("[data-summary-text]");
  const noDuplicateSelection = container.dataset.noDuplicateSelection === "true";

  const charmImageEls = container.querySelectorAll("[data-charm-image]");
  charmImageEls.forEach((el) => {
    const src = el.getAttribute("data-charm-image");
    if (src) {
      const img = new Image();
      img.src = src;
    }
  });

  function getLinkedGroupName() {
    return document.querySelector(".diy-charms-arc")?.getAttribute("data-linked-option-group") || "charm";
  }

  function getSlotIndex(group) {
    return parseInt(group.getAttribute("data-slot-index") || "1", 10);
  }

  function getSelectedVariant(group) {
    return group.querySelector('.custom-option-group__variant[data-selected="true"]');
  }

  function getCharmPreviewSource(variant) {
    return variant.querySelector("[data-charm-image]")?.dataset.charmImage || variant.querySelector(".custom-option-group__variant-image img")?.src || "";
  }

  function updateGroupSelectedInfo(group) {
    const selectedInfoContainer = group.querySelector(".custom-option-group__selected-info");
    if (!selectedInfoContainer) return;

    const selectedVariant = getSelectedVariant(group);

    if (selectedVariant) {
      const name = selectedVariant.getAttribute("data-variant-name");
      const price = parseInt(selectedVariant.getAttribute("data-variant-price") || "0", 10);
      const imgEl = selectedVariant.querySelector(".custom-option-group__variant-image img");

      selectedInfoContainer.querySelector(".custom-option-group__selected-image").innerHTML = imgEl
        ? `<img src="${imgEl.src}" alt="${name}" style="width: 50px; height: 50px; object-fit: cover;">`
        : "";
      selectedInfoContainer.querySelector(".custom-option-group__selected-title").textContent = name;

      const priceEl = selectedInfoContainer.querySelector(".custom-option-group__selected-price");
      if (price > 0) {
        priceEl.innerHTML = `<span class="money">${Shopify.formatMoney(price)}</span>`;
      } else {
        priceEl.innerHTML = "";
      }

      selectedInfoContainer.style.display = "flex";
      selectedInfoContainer.style.alignItems = "center";
      selectedInfoContainer.style.gap = "15px";
      selectedInfoContainer.style.marginBottom = "15px";
    } else {
      selectedInfoContainer.style.display = "none";
    }
  }

  function collapseLinkedGroups() {
    groups.forEach((group) => {
      if (!group.classList.contains("custom-option-group--linked")) return;

      const variantsContainer = group.querySelector(".custom-option-group__variants");
      const toggleIcon = group.querySelector(".custom-option-group__toggle-icon");

      if (variantsContainer) {
        variantsContainer.classList.remove("expanded");
        variantsContainer.style.maxHeight = "0";
        variantsContainer.style.opacity = "0";
      }

      if (toggleIcon) {
        toggleIcon.style.transform = "rotate(0deg)";
      }
    });
  }

  function expandLinkedGroupBySlot(slotIndex) {
    const targetGroup = groups.find(
      (group) =>
        group.classList.contains("custom-option-group--linked") &&
        group.getAttribute("data-group-name")?.toLowerCase() === getLinkedGroupName().toLowerCase() &&
        getSlotIndex(group) === slotIndex,
    );

    if (!targetGroup) return;

    collapseLinkedGroups();

    const variantsContainer = targetGroup.querySelector(".custom-option-group__variants");
    const toggleIcon = targetGroup.querySelector(".custom-option-group__toggle-icon");

    if (variantsContainer) {
      variantsContainer.classList.add("expanded");
      variantsContainer.style.maxHeight = "1000px";
      variantsContainer.style.opacity = "1";
    }

    if (toggleIcon) {
      toggleIcon.style.transform = "rotate(180deg)";
    }
  }

  function getSelectedCharmSlots() {
    return groups
      .filter((group) => group.classList.contains("custom-option-group--linked"))
      .map((group) => {
        const selectedVariant = getSelectedVariant(group);
        if (!selectedVariant) return null;

        return {
          slotIndex: getSlotIndex(group),
          src: getCharmPreviewSource(selectedVariant),
          name: selectedVariant.getAttribute("data-variant-name") || "",
        };
      })
      .filter(Boolean)
      .sort((a, b) => a.slotIndex - b.slotIndex);
  }

  function syncCharmPreviewActiveSlot(activeSlotIndex) {
    window.dispatchEvent(
      new CustomEvent("diy-charm:active-slot-changed", {
        detail: {
          linkedGroup: getLinkedGroupName(),
          activeSlotIndex: activeSlotIndex || 1,
        },
      }),
    );
  }

  function syncCharmPreviewSelection(activeSlotIndex) {
    window.dispatchEvent(
      new CustomEvent("diy-charm:selection-changed", {
        detail: {
          linkedGroup: getLinkedGroupName(),
          activeSlotIndex: activeSlotIndex || 1,
          slots: getSelectedCharmSlots(),
        },
      }),
    );
  }

  window.addEventListener("diy-charm:placeholder-selected", (event) => {
    const { index, linkedGroup } = event.detail || {};
    if (!linkedGroup) return;
    if (linkedGroup.toLowerCase() !== getLinkedGroupName().toLowerCase()) return;

    expandLinkedGroupBySlot(index);
    syncCharmPreviewActiveSlot(index);
  });

  groups.forEach((group) => {
    const header = group.querySelector(".custom-option-group__header");
    if (header) {
      header.addEventListener("click", () => {
        const variantsContainer = group.querySelector(".custom-option-group__variants");
        const toggleIcon = group.querySelector(".custom-option-group__toggle-icon");
        const isLinkedGroup = group.classList.contains("custom-option-group--linked");
        const slotIndex = getSlotIndex(group);

        if (!variantsContainer) return;

        const isExpanded = variantsContainer.classList.contains("expanded");

        if (isLinkedGroup) {
          if (isExpanded) {
            variantsContainer.classList.remove("expanded");
            variantsContainer.style.maxHeight = "0";
            variantsContainer.style.opacity = "0";
            if (toggleIcon) toggleIcon.style.transform = "rotate(0deg)";
          } else {
            expandLinkedGroupBySlot(slotIndex);
          }
          syncCharmPreviewActiveSlot(slotIndex);
          return;
        }

        if (isExpanded) {
          variantsContainer.classList.remove("expanded");
          variantsContainer.style.maxHeight = "0";
          variantsContainer.style.opacity = "0";
          if (toggleIcon) toggleIcon.style.transform = "rotate(0deg)";
        } else {
          variantsContainer.classList.add("expanded");
          variantsContainer.style.maxHeight = "1000px";
          variantsContainer.style.opacity = "1";
          if (toggleIcon) toggleIcon.style.transform = "rotate(180deg)";
        }
      });
    }
  });

  groups.forEach((group) => {
    const variants = group.querySelectorAll(".custom-option-group__variant");

    variants.forEach((variant) => {
      variant.addEventListener("click", () => {
        const pswiperEl = document.querySelector(".pswiper");
        const pswiperThumbEl = document.querySelector(".pswiper-thumb");

        if (pswiperEl && pswiperEl.swiper) pswiperEl.swiper.slideTo(0);
        if (pswiperThumbEl && pswiperThumbEl.swiper) pswiperThumbEl.swiper.slideTo(0);
        if (variant.hasAttribute("data-disabled")) return;

        const isSelected = variant.hasAttribute("data-selected");
        const isLinkedGroup = group.classList.contains("custom-option-group--linked");
        const slotIndex = getSlotIndex(group);

        variants.forEach((item) => item.removeAttribute("data-selected"));

        if (!isSelected) {
          variant.setAttribute("data-selected", "true");
        }

        updateGroupSelectedInfo(group);
        updateDuplicateDisabled();
        updateBundleCart();
        updateSummary();

        if (isLinkedGroup) {
          expandLinkedGroupBySlot(slotIndex);
          syncCharmPreviewActiveSlot(slotIndex);
          syncCharmPreviewSelection(slotIndex);
        }
      });
    });
  });

  function updateDuplicateDisabled() {
    if (!noDuplicateSelection) return;

    const selectedIdsByGroup = new Map();
    groups.forEach((group) => {
      const selected = getSelectedVariant(group);
      if (selected) {
        selectedIdsByGroup.set(group, selected.getAttribute("data-variant-id"));
      }
    });

    groups.forEach((group) => {
      const idsInOtherGroups = new Set(
        [...selectedIdsByGroup.entries()].filter(([g]) => g !== group).map(([, id]) => id),
      );

      group.querySelectorAll(".custom-option-group__variant").forEach((variant) => {
        if (variant.dataset.soldOut === "true") return;
        const id = variant.getAttribute("data-variant-id");
        if (idsInOtherGroups.has(id)) {
          variant.classList.add("disabled");
          variant.setAttribute("data-disabled", "true");
        } else {
          variant.classList.remove("disabled");
          variant.removeAttribute("data-disabled");
        }
      });
    });
  }

  function updateBundleCart() {
    const bundleItems = [];
    const selectedVariants = container.querySelectorAll('.custom-option-group__variant[data-selected="true"]');

    selectedVariants.forEach((variant) => {
      const variantId = variant.dataset.variantId || variant.getAttribute("data-variant-id");
      const name = variant.getAttribute("data-variant-name") || "";
      const price = parseInt(variant.getAttribute("data-variant-price") || "0", 10);

      if (!variantId) return;

      const existingItem = bundleItems.find((item) => item.id === String(variantId));
      if (existingItem) {
        existingItem.quantity += 1;
      } else {
        bundleItems.push({
          id: String(variantId),
          quantity: 1,
          name: name,
          price: price,
        });
      }
    });

    container.setAttribute("data-bundle-items", JSON.stringify(bundleItems));
  }

  function getSelectedCharmData(productPrice) {
    const selectedCharmVariants = groups
      .filter((group) => group.classList.contains("custom-option-group--linked"))
      .map((group) => getSelectedVariant(group))
      .filter(Boolean);

    const charmCount = selectedCharmVariants.length;
    const charmSubtotal = selectedCharmVariants.reduce((total, variant) => {
      return total + parseInt(variant.getAttribute("data-variant-price") || "0", 10);
    }, 0);

    let discountRate = 0;
    let discountLabel = "";

    if (charmCount >= 3) {
      discountRate = 0.1;
      discountLabel = summaryText.getAttribute("data-discount-three-label") || "";
    } else if (charmCount === 2) {
      discountRate = 0.05;
      discountLabel = summaryText.getAttribute("data-discount-two-label") || "";
    }

    const discountBaseCents = productPrice + charmSubtotal;
    const discountCents = Math.floor(discountBaseCents * discountRate);

    return {
      charmCount,
      charmSubtotal,
      discountBaseCents,
      discountRate,
      discountCents,
      discountLabel,
    };
  }

  function updateSummary() {
    let totalOptionsPrice = 0;
    let totalSelected = 0;

    const bundleItemsAttr = container.getAttribute("data-bundle-items");
    let bundleItems = [];

    if (bundleItemsAttr) {
      try {
        bundleItems = JSON.parse(bundleItemsAttr);
      } catch (error) {
        console.error("Failed to parse bundle items:", error);
      }
    }

    bundleItems.forEach((item) => {
      totalOptionsPrice += item.price * item.quantity;
      totalSelected += item.quantity;
    });

    if (totalSelected === 0) {
      summaryContainer.style.display = "none";
      document.querySelectorAll("[data-total-options-price]").forEach((el) => {
        el.style.display = "none";
      });
      return;
    }

    const variantTitle = summaryText.getAttribute("data-product-variant-name");
    const productTitle = summaryText.getAttribute("data-product-title");
    const productVariantName = variantTitle && variantTitle !== "Default Title" ? variantTitle : "";
    const productPrice = parseInt(summaryText.getAttribute("data-product-price") || "0", 10);
    const freeLabel = summaryText.getAttribute("data-free-label") || "Free";
    const totalLabel = summaryText.getAttribute("data-total-label") || "Total";
    const charmData = getSelectedCharmData(productPrice);
    const totalPrice = totalOptionsPrice + productPrice - charmData.discountCents;
    const totalPriceFormatted = Shopify.formatMoney(totalPrice);

    document.querySelectorAll("[data-total-options-price]").forEach((el) => {
      if (totalOptionsPrice > 0) {
        el.innerHTML = `+ <span class="money">${Shopify.formatMoney(totalOptionsPrice)}</span>`;
        el.style.display = "block";
      } else {
        el.style.display = "none";
      }
    });

    let listHTML = '<div class="custom-option-groups__summary-list">';

    listHTML += `
      <div class="custom-option-groups__summary-item">
        <div class="custom-option-groups__summary-item-left">${productTitle}</div>
        <div class="custom-option-groups__summary-item-right">
          <div class="custom-option-groups__summary-item-variant">${productVariantName}</div>
          <div class="custom-option-groups__summary-item-price"><span class="money">${Shopify.formatMoney(productPrice)}</span></div>
        </div>
      </div>
    `;

    bundleItems.forEach((item) => {
      const itemTotalPrice = item.price * item.quantity;
      listHTML += `
        <div class="custom-option-groups__summary-item">
          <div class="custom-option-groups__summary-item-left">${item.name} * ${item.quantity}</div>
          <div class="custom-option-groups__summary-item-right">
            <div class="custom-option-groups__summary-item-variant"></div>
            <div class="custom-option-groups__summary-item-price">${itemTotalPrice > 0 ? `<span class="money">${Shopify.formatMoney(itemTotalPrice)}</span>` : freeLabel}</div>
          </div>
        </div>
      `;
    });

    listHTML += "</div>";

    if (charmData.discountCents > 0 && charmData.discountLabel) {
      listHTML += `
        <div class="custom-option-groups__summary-discounts">
          <div class="custom-option-groups__summary-discount-item">
            <div class="custom-option-groups__summary-discount-label">${charmData.discountLabel}</div>
            <div class="custom-option-groups__summary-discount-value">- <span class="money">${Shopify.formatMoney(charmData.discountCents)}</span></div>
          </div>
        </div>
      `;
    }

    listHTML += `
      <div class="custom-option-groups__summary-total">
        <div class="custom-option-groups__summary-total-left">${totalLabel}</div>
        <div class="custom-option-groups__summary-total-right"><span class="money">${totalPriceFormatted}</span></div>
      </div>
    `;

    summaryText.innerHTML = listHTML;
    summaryContainer.style.display = "block";
  }

  function updateCharmsSlotVisibility(maxAvailableCount) {
    groups.forEach((group) => {
      if (!group.classList.contains("custom-option-group--linked")) return;
      const slotIndex = getSlotIndex(group);
      if (slotIndex > maxAvailableCount) {
        group.style.display = "none";
        const selected = getSelectedVariant(group);
        if (selected) {
          selected.removeAttribute("data-selected");
          updateGroupSelectedInfo(group);
        }
      } else {
        group.style.display = "";
      }
    });
    updateDuplicateDisabled();
    updateBundleCart();
    updateSummary();
  }

  window.addEventListener("enroute:variant-changed", (event) => {
    const variant = event.detail?.variant;
    if (!variant) return;

    if (variant.title) {
      summaryText.setAttribute("data-product-variant-name", variant.title);
    }
    if (variant.price) {
      summaryText.setAttribute("data-product-price", variant.price);
    }

    const maxCharmsCount = parseInt(container.dataset.maxCharmsCount || "0", 10);
    if (maxCharmsCount > 0) {
      const variantMax = parseInt(variant.max || "9999", 10);
      const newMaxAvailable = Math.min(maxCharmsCount, isFinite(variantMax) ? variantMax : maxCharmsCount);
      container.dataset.maxAvailableCount = String(newMaxAvailable);
      updateCharmsSlotVisibility(newMaxAvailable);
    } else {
      updateSummary();
    }
  });

  setTimeout(() => {
    groups.forEach((group) => updateGroupSelectedInfo(group));
    updateDuplicateDisabled();
    updateBundleCart();
    updateSummary();

    const firstLinkedGroup = groups.find((group) => group.classList.contains("custom-option-group--linked"));
    if (firstLinkedGroup) {
      const slotIndex = getSlotIndex(firstLinkedGroup);
      expandLinkedGroupBySlot(slotIndex);
      syncCharmPreviewActiveSlot(slotIndex);
      syncCharmPreviewSelection(slotIndex);
    } else {
      syncCharmPreviewActiveSlot(1);
      syncCharmPreviewSelection(1);
    }
  }, 100);
});
